module.exports = __webpack_public_path__ + "static/Joseph_Liu_Resume-aaffbbddeafd1b8992d1d4d2d11120f5.pdf";